var _path, _path2, _path3, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoadmapOff = function SvgRoadmapOff(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2215 21.6712C10.3822 20.7068 11.2166 20 12.1943 20H23.8057C24.7834 20 25.6178 20.7068 25.7785 21.6712L26.6119 26.6712C26.815 27.8903 25.875 29 24.6391 29H11.3609C10.125 29 9.18496 27.8903 9.38813 26.6712L10.2215 21.6712Z",
    fill: "#5F606D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9317 25.0974L17.9554 25.1029L17.9789 25.097C18.0712 25.0738 18.1743 25.0215 18.2842 24.9494C18.3953 24.8766 18.5186 24.7801 18.6515 24.6634C18.9174 24.4299 19.2271 24.1111 19.5622 23.7276C20.2326 22.9602 21.0097 21.9281 21.7478 20.7878C22.4859 19.6475 23.1866 18.3967 23.7031 17.1921C24.2188 15.9893 24.5546 14.824 24.5546 13.8571C24.5546 10.0199 21.6046 6.9 17.9546 6.9C14.3045 6.9 11.3546 10.0199 11.3546 13.8571C11.3546 14.8237 11.6849 15.9888 12.1939 17.1916C12.7036 18.3963 13.3963 19.6471 14.1291 20.7875C14.8619 21.9279 15.6365 22.9602 16.3111 23.7278C16.6483 24.1114 16.9619 24.4305 17.234 24.6641C17.5019 24.8942 17.7423 25.0529 17.9317 25.0974ZM20.4546 13.4286C20.4546 14.7925 19.3364 15.9 17.9546 15.9C16.5729 15.9 15.4546 14.7925 15.4546 13.4286C15.4546 12.0647 16.5729 10.9571 17.9546 10.9571C19.3364 10.9571 20.4546 12.0647 20.4546 13.4286Z",
    stroke: "url(#paint0_linear_54_938)",
    strokeOpacity: 0.6,
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9546 25C19.1793 24.6925 24.4546 17.6442 24.4546 13.8571C24.4546 10.07 21.5444 7 17.9546 7C14.3647 7 11.4546 10.07 11.4546 13.8571C11.4546 17.6442 16.6443 24.6925 17.9546 25ZM17.9546 16C19.3906 16 20.5546 14.8487 20.5546 13.4286C20.5546 12.0084 19.3906 10.8571 17.9546 10.8571C16.5187 10.8571 15.3546 12.0084 15.3546 13.4286C15.3546 14.8487 16.5187 16 17.9546 16Z",
    fill: "#5F606D",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_54_938",
    x: 3.25464,
    y: -1.2,
    width: 29.3999,
    height: 34.4058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_938",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_54_938",
    x: 7.45459,
    y: 3,
    width: 21,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_54_938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_54_938",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54_938",
    x1: 10.526,
    y1: 8.63636,
    x2: 30.9529,
    y2: 16.2536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoadmapOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/RoadmapOff.ab916e97.svg";
export { ForwardRef as ReactComponent };